var _defs, _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _ellipse2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g, _g2, _g3, _rect, _path24, _path25, _circle, _circle2, _circle3, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0340_web_developer",
    "data-name": "0340_web_developer",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    "data-imageid": "coding-5-64",
    imageName: "Coding 5",
    className: "illustrations_image",
    style: {
      width: 188
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1_coding-5-64{fill:#68e1fd;}.cls-2_coding-5-64{fill:#093f68;}.cls-3_coding-5-64{fill:#ffc9b0;}.cls-4_coding-5-64{fill:#725858;}.cls-5_coding-5-64{fill:#fff;}.cls-6_coding-5-64{fill:#f56132;}.cls-7_coding-5-64{fill:#ffbc0e;}"))), /*#__PURE__*/React.createElement("g", {
    id: "character_coding-5-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1_coding-5-64 targetColor",
    d: "M289.1,273h32.78a57.77,57.77,0,0,1,55.24,40.84l17.71,57.77a13.81,13.81,0,0,1-13.21,17.86H229.37a13.81,13.81,0,0,1-13.21-17.86l17.71-57.77A57.77,57.77,0,0,1,289.1,273Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M381.62,391.32H229.37a15.69,15.69,0,0,1-15-20.3l17.71-57.77a59.34,59.34,0,0,1,57-42.17h32.78a59.35,59.35,0,0,1,57,42.17L396.63,371a15.69,15.69,0,0,1-15,20.3ZM289.1,274.85a55.6,55.6,0,0,0-53.43,39.51L218,372.13a11.93,11.93,0,0,0,11.41,15.43H381.62A11.93,11.93,0,0,0,393,372.13l-17.71-57.77a55.6,55.6,0,0,0-53.44-39.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3_coding-5-64",
    d: "M295.48,266.45h20a0,0,0,0,1,0,0V282a4.52,4.52,0,0,1-4.52,4.52H300a4.52,4.52,0,0,1-4.52-4.52v-15.5A0,0,0,0,1,295.48,266.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M307,288.35h-3A10.4,10.4,0,0,1,293.6,278V266.44a1.88,1.88,0,0,1,1.88-1.88h20a1.88,1.88,0,0,1,1.88,1.88V278A10.4,10.4,0,0,1,307,288.35Zm-9.64-20V278a6.62,6.62,0,0,0,6.61,6.61h3a6.62,6.62,0,0,0,6.61-6.61v-9.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4_coding-5-64",
    d: "M236.37,210.9c-9.29-3.52-8.72-10.62-10.13-19.74a234.94,234.94,0,0,1-2.56-27.25c-.36-10.37,0-21,3.95-30.64,5.05-12.37,15-20.36,28.39-19.26-.39-18.22,10.54-35.32,29.92-36.35,31-1.65,48.88,31.67,66.26,29.19s22-10.19,22-10.19,10.35,17.74-3.72,35.13c0,0,13.67-4,15.33,14.21s-9.23,66.58-9.23,66.58l-12.42-2.17c-5.21-.92-11.72.36-17,.53l-38.8,1.21C289,212.76,257.49,218.89,236.37,210.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M264.35,216.84c-10.2,0-20.23-1-28.64-4.18h0c-9-3.42-9.86-9.94-10.82-17.49-.15-1.2-.31-2.44-.51-3.73A236.12,236.12,0,0,1,221.8,164c-.34-9.75-.12-21.11,4.09-31.41,5.38-13.17,15.38-20.53,27.68-20.53h.57c.42-17.52,11.17-35.16,31.71-36.25,18-.94,31.95,9.57,43.14,18,8.62,6.52,16.07,12.15,22.95,11.17,16.08-2.3,20.61-9.25,20.65-9.32a1.9,1.9,0,0,1,3.24,0c.1.17,9.53,16.79-1.42,33.85a12.82,12.82,0,0,1,6.54,2.15c3.85,2.62,6.12,7.37,6.73,14.12,1.66,18.3-8.82,65.17-9.27,67.16a1.89,1.89,0,0,1-2.16,1.44l-12.41-2.17c-3.27-.57-7.22-.21-11,.15-1.94.18-3.78.35-5.55.41L308.45,214c-4.85.15-10.52.66-16.53,1.19C283.35,216,273.78,216.84,264.35,216.84ZM237,209.14c15.39,5.82,37.1,3.89,54.55,2.33,6.06-.54,11.79-1.05,16.74-1.2l38.8-1.21c1.65-.06,3.43-.22,5.31-.4,4.07-.38,8.27-.77,12-.11h0l10.64,1.85c1.92-8.81,10.25-48.46,8.81-64.23-.5-5.56-2.21-9.37-5.07-11.34A10.24,10.24,0,0,0,371,133.6a1.89,1.89,0,0,1-2-3A29.6,29.6,0,0,0,373.73,100c-2.89,2.71-9.16,6.95-21.26,8.67-8.43,1.2-16.46-4.86-25.75-11.89-11.26-8.52-24-18.17-40.68-17.28-18.93,1-28.49,18.08-28.13,34.43a1.88,1.88,0,0,1-.6,1.41,1.93,1.93,0,0,1-1.44.51c-11.75-1-21.4,5.63-26.5,18.09-3.93,9.65-4.13,20.51-3.81,29.86a231,231,0,0,0,2.54,27c.21,1.32.37,2.59.53,3.82.9,7.12,1.5,11.83,8.41,14.45Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3_coding-5-64",
    cx: 248.28,
    cy: 214.44,
    rx: 19.45,
    ry: 16.76
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M248.28,233.08c-11.77,0-21.34-8.36-21.34-18.64s9.57-18.64,21.34-18.64,21.33,8.36,21.33,18.64S260,233.08,248.28,233.08Zm0-33.52c-9.69,0-17.57,6.68-17.57,14.88s7.88,14.88,17.57,14.88,17.57-6.67,17.57-14.88S258,199.56,248.28,199.56Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3_coding-5-64",
    cx: 361.68,
    cy: 214.44,
    rx: 19.45,
    ry: 16.76
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M361.68,233.08c-11.77,0-21.34-8.36-21.34-18.64s9.57-18.64,21.34-18.64S383,204.16,383,214.44,373.44,233.08,361.68,233.08Zm0-33.52c-9.69,0-17.57,6.68-17.57,14.88s7.88,14.88,17.57,14.88,17.56-6.67,17.56-14.88S371.36,199.56,361.68,199.56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3_coding-5-64",
    d: "M305.49,269.07h0a58.66,58.66,0,0,1-58.66-58.66v-42.6c3.43,5.64,14.82,3.4,31.5-25.24,62.5,31.66,85.83,13.52,85.83,13.52v54.32A58.66,58.66,0,0,1,305.49,269.07Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M305.49,271A60.61,60.61,0,0,1,245,210.41v-42.6a1.88,1.88,0,0,1,3.49-1,3.13,3.13,0,0,0,2.88,1.58h.05c2.29,0,10.91-2,25.34-26.79a1.89,1.89,0,0,1,2.48-.73c60.37,30.59,83.6,13.88,83.82,13.7a1.89,1.89,0,0,1,2-.18,1.86,1.86,0,0,1,1.05,1.68v54.32A60.61,60.61,0,0,1,305.49,271Zm-56.78-99.23v38.69a56.79,56.79,0,0,0,113.57,0V159.33c-8.13,3.86-33.11,10.7-83.22-14.29-10.39,17.45-20.18,27.06-27.66,27.13A6.73,6.73,0,0,1,248.71,171.72Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M343.1,375.58a1.88,1.88,0,0,1-1.88-1.88V304.85a1.89,1.89,0,0,1,3.77,0V373.7A1.88,1.88,0,0,1,343.1,375.58Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M267.88,375.58A1.88,1.88,0,0,1,266,373.7V304.85a1.89,1.89,0,0,1,3.77,0V373.7A1.89,1.89,0,0,1,267.88,375.58Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M305.36,221.18a37.16,37.16,0,0,1-5.88-.49,1.88,1.88,0,1,1,.65-3.71c.06,0,5.27.91,8.94.09.37-1.73-1.91-8.19-5.07-14.25a1.88,1.88,0,1,1,3.33-1.75c2.12,4.05,6.84,13.89,5.11,17.74a3.23,3.23,0,0,1-2.18,1.85A20.61,20.61,0,0,1,305.36,221.18Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M292.42,176.08h0L263.65,176a3.77,3.77,0,0,1,0-7.53h0l28.76.07a3.76,3.76,0,1,1,0,7.52Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M345.52,176.08h0L316.75,176a3.77,3.77,0,0,1,0-7.53h0l28.76.07a3.76,3.76,0,1,1,0,7.52Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5_coding-5-64",
    d: "M258.82,186.41h38.43a2.56,2.56,0,0,1,2.56,2.56v6.92a14.74,14.74,0,0,1-14.74,14.74H271a14.74,14.74,0,0,1-14.74-14.74V189A2.56,2.56,0,0,1,258.82,186.41Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M283.56,212.5h-11a18.16,18.16,0,0,1-18.14-18.13v-3.15a6.71,6.71,0,0,1,6.7-6.7H295a6.71,6.71,0,0,1,6.7,6.7v3.15A18.15,18.15,0,0,1,283.56,212.5Zm-22.48-24.21a2.93,2.93,0,0,0-2.93,2.93v3.15a14.38,14.38,0,0,0,14.37,14.37h11a14.38,14.38,0,0,0,14.36-14.37v-3.15a2.93,2.93,0,0,0-2.93-2.93Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5_coding-5-64",
    d: "M313.52,186.41h38.43A2.56,2.56,0,0,1,354.5,189v6.92a14.74,14.74,0,0,1-14.74,14.74H325.7A14.74,14.74,0,0,1,311,195.88V189A2.56,2.56,0,0,1,313.52,186.41Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M338.25,212.5h-11a18.15,18.15,0,0,1-18.13-18.13v-3.15a6.7,6.7,0,0,1,6.69-6.7h33.92a6.7,6.7,0,0,1,6.69,6.7v3.15A18.15,18.15,0,0,1,338.25,212.5Zm-22.48-24.21a2.93,2.93,0,0,0-2.93,2.93v3.15a14.38,14.38,0,0,0,14.37,14.37h11a14.39,14.39,0,0,0,14.37-14.37v-3.15a2.93,2.93,0,0,0-2.93-2.93Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M256.27,196.25H245.34a1.88,1.88,0,0,1,0-3.76h10.93a1.88,1.88,0,0,1,0,3.76Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M366,196.25H355.05a1.88,1.88,0,0,1,0-3.76H366a1.88,1.88,0,0,1,0,3.76Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M311,196.25H299.81a1.88,1.88,0,1,1,0-3.76H311a1.88,1.88,0,0,1,0,3.76Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M304.25,239.32a54.41,54.41,0,0,1-19.65-3.59,1.88,1.88,0,0,1,1.36-3.51c19.05,7.36,37,.09,37.2,0a1.88,1.88,0,1,1,1.45,3.47A57.14,57.14,0,0,1,304.25,239.32Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M357.11,359.76a1.88,1.88,0,0,1-.38-3.72l20.81-4.25a1.88,1.88,0,0,1,.76,3.69l-20.81,4.24A1.69,1.69,0,0,1,357.11,359.76Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M253.88,359.76a1.64,1.64,0,0,1-.38,0l-20.81-4.24a1.88,1.88,0,0,1,.75-3.69L254.25,356a1.88,1.88,0,0,1-.37,3.72Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M304,322.2a1.88,1.88,0,0,1-1.88-1.88V286.47a1.89,1.89,0,1,1,3.77,0v33.85A1.89,1.89,0,0,1,304,322.2Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "device_coding-5-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6_coding-5-64",
    d: "M252.76,320.32H358a9.41,9.41,0,0,1,9.41,9.41V391.2a0,0,0,0,1,0,0h-124a0,0,0,0,1,0,0V329.72A9.41,9.41,0,0,1,252.76,320.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M367.41,393.08h-124a1.88,1.88,0,0,1-1.88-1.88V329.32a10.9,10.9,0,0,1,10.88-10.89h106a10.91,10.91,0,0,1,10.89,10.89V391.2A1.88,1.88,0,0,1,367.41,393.08Zm-122.17-3.76H365.52v-60a7.12,7.12,0,0,0-7.12-7.12h-106a7.13,7.13,0,0,0-7.12,7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6_coding-5-64",
    d: "M237.33,391.2h136.1a0,0,0,0,1,0,0v1.39a7.69,7.69,0,0,1-7.69,7.69H245a7.69,7.69,0,0,1-7.69-7.69V391.2A0,0,0,0,1,237.33,391.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M364.35,402.16H246.41a11,11,0,0,1-11-11,1.88,1.88,0,0,1,1.88-1.88h136.1a1.88,1.88,0,0,1,1.88,1.88A11,11,0,0,1,364.35,402.16Zm-124.88-9.08a7.19,7.19,0,0,0,6.94,5.31H364.35a7.21,7.21,0,0,0,6.95-5.31Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "table_coding-5-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4_coding-5-64",
    x: 82.49,
    y: 400.28,
    width: 336.88,
    height: 22.12,
    rx: 10.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M408.31,424.28H93.55a12.95,12.95,0,0,1,0-25.89H408.31a12.95,12.95,0,0,1,0,25.89ZM93.55,402.16a9.18,9.18,0,0,0,0,18.36H408.31a9.18,9.18,0,0,0,0-18.36Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "glass_coding-5-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7_coding-5-64",
    d: "M125.49,345.82h52.7a0,0,0,0,1,0,0V384.6a15.68,15.68,0,0,1-15.68,15.68H141.17a15.68,15.68,0,0,1-15.68-15.68V345.82A0,0,0,0,1,125.49,345.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M160.9,402.16H142.79A19.19,19.19,0,0,1,123.61,383V345.82a1.88,1.88,0,0,1,1.88-1.88h52.7a1.88,1.88,0,0,1,1.88,1.88V383A19.19,19.19,0,0,1,160.9,402.16ZM127.38,347.7V383a15.42,15.42,0,0,0,15.41,15.4H160.9A15.42,15.42,0,0,0,176.31,383V347.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M181.27,383.72h-3.08a1.88,1.88,0,0,1-1.88-1.88v-30a1.88,1.88,0,0,1,1.88-1.88h3.08a16.86,16.86,0,1,1,0,33.72Zm-1.2-3.76h1.2a13.1,13.1,0,0,0,0-26.2h-1.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "tab_coding-5-64"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5_coding-5-64",
    x: 87.58,
    y: 180.32,
    width: 121,
    height: 101.77,
    rx: 2.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M203.88,284H92.28a6.59,6.59,0,0,1-6.58-6.58V185a6.58,6.58,0,0,1,6.58-6.57h111.6a6.58,6.58,0,0,1,6.58,6.57v92.38A6.59,6.59,0,0,1,203.88,284ZM92.28,182.2A2.81,2.81,0,0,0,89.46,185v92.38a2.82,2.82,0,0,0,2.82,2.82h111.6a2.83,2.83,0,0,0,2.82-2.82V185a2.82,2.82,0,0,0-2.82-2.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1_coding-5-64 targetColor",
    d: "M90.07,180.32h116a2.5,2.5,0,0,1,2.5,2.5v10.36a0,0,0,0,1,0,0h-121a0,0,0,0,1,0,0V182.81A2.5,2.5,0,0,1,90.07,180.32Z",
    style: {
      fill: "rgb(33, 72, 29)"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M208.58,195.06h-121a1.89,1.89,0,0,1-1.88-1.89V185a6.58,6.58,0,0,1,6.58-6.57h111.6a6.58,6.58,0,0,1,6.58,6.57v8.16A1.89,1.89,0,0,1,208.58,195.06ZM89.46,191.29H206.7V185a2.82,2.82,0,0,0-2.82-2.81H92.28A2.81,2.81,0,0,0,89.46,185Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2_coding-5-64",
    cx: 96.97,
    cy: 186.74,
    r: 2.52
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2_coding-5-64",
    cx: 104.04,
    cy: 186.74,
    r: 2.52
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2_coding-5-64",
    cx: 111.11,
    cy: 186.74,
    r: 2.52
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M132.51,228.64l-17.41,7.94v.13l17.41,7.93v8.71l-27.79-12.67v-8.07l27.79-12.67Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M153.16,207.33l6.26,2.24-16.48,49.86-6.2-2.24Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_coding-5-64",
    d: "M163.65,244.64l17.41-7.93v-.13l-17.41-7.94v-8.7l27.79,12.67v8.07l-27.79,12.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelop);
export default __webpack_public_path__ + "static/media/develop.aff3070c259e772b7a0715257739bcbb.svg";
export { ForwardRef as ReactComponent };